// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.bs.mjs";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.bs.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as Modal$LumiFacilityInfo from "./Modal.bs.mjs";
import * as State$LumiFacilityInfo from "./State.bs.mjs";
import * as Translation$LumiFacilityInfo from "./Translation.bs.mjs";

function BikeFacilityList$Facility(props) {
  var imgBikeLower = props.imgBikeLower;
  var imgBikeUpper = props.imgBikeUpper;
  var fullThreshold = props.fullThreshold;
  var zippedParkingCounts = props.zippedParkingCounts;
  var locale = Locale$LumiI18n.useContext();
  var match = React.useState(function () {
        return false;
      });
  var lower = zippedParkingCounts.lower;
  var upper = zippedParkingCounts.upper;
  var info = zippedParkingCounts.info;
  var setShowModal = match[1];
  var state = State$LumiFacilityInfo.fromParkingCounts(zippedParkingCounts.total, fullThreshold);
  var name = info.name;
  var shortAddress = props.displayAddress(info.address);
  var now = new Date();
  var nextOpenCloseEvent = info.openingTimes.find(function (param) {
        return Caml_obj.greaterthan(param[0], now);
      });
  var tmp;
  if (nextOpenCloseEvent !== undefined) {
    var time = nextOpenCloseEvent[0];
    tmp = nextOpenCloseEvent[1] === "Open" ? ({
          TAG: "OpensAt",
          _0: time
        }) : ({
          TAG: "OpenUntil",
          _0: time
        });
  } else {
    tmp = "Open247";
  }
  var tmp$1;
  var exit = 0;
  if (typeof state !== "object" || state.TAG !== "Free") {
    exit = 1;
  } else {
    var tmp$2;
    var exit$1 = 0;
    if (upper !== undefined || lower !== undefined) {
      exit$1 = 2;
    } else {
      tmp$2 = JsxRuntime.jsx("p", {
            children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                  entry: {
                    TAG: "FacilityState",
                    _0: state
                  }
                }),
            className: "facility-status-ok is-size-2"
          });
    }
    if (exit$1 === 2) {
      tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              LumiReact.renderOption(undefined, Core__Option.map(upper, (function (param) {
                          return State$LumiFacilityInfo.fromParkingCounts(param, fullThreshold);
                        })), (function (state) {
                      return JsxRuntime.jsxs("p", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "rack-bike-top-image",
                                          alt: Translation$LumiFacilityInfo.Provider.$$Text.string(locale, "UpperPlaces"),
                                          src: imgBikeUpper
                                        }),
                                    JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                          entry: {
                                            TAG: "FacilityState",
                                            _0: state
                                          }
                                        })
                                  ],
                                  className: "facility-status-ok is-size-5"
                                });
                    })),
              LumiReact.renderOption(undefined, Core__Option.map(lower, (function (param) {
                          return State$LumiFacilityInfo.fromParkingCounts(param, fullThreshold);
                        })), (function (state) {
                      return JsxRuntime.jsxs("p", {
                                  children: [
                                    JsxRuntime.jsx("img", {
                                          className: "rack-bike-bottom-image",
                                          alt: Translation$LumiFacilityInfo.Provider.$$Text.string(locale, "LowerPlaces"),
                                          src: imgBikeLower
                                        }),
                                    JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                          entry: {
                                            TAG: "FacilityState",
                                            _0: state
                                          }
                                        })
                                  ],
                                  className: "facility-status-ok is-size-5"
                                });
                    }))
            ]
          });
    }
    tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("p", {
                  children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                        entry: "FreePlaces"
                      }),
                  className: "facility-status-ok is-size-6"
                }),
            tmp$2
          ]
        });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                entry: {
                  TAG: "FacilityState",
                  _0: state
                }
              }),
          className: LumiReact.classList([
                [
                  "is-size-2",
                  true
                ],
                [
                  "facility-status-bad",
                  state === "Closed" || state === "Full"
                ],
                [
                  "facility-status-warning",
                  state === "Busy"
                ],
                [
                  "facility-status-ok",
                  state === "Open"
                ]
              ])
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                match[0] ? JsxRuntime.jsx(Modal$LumiFacilityInfo.make, {
                        name: name,
                        website: props.website,
                        address: info.address,
                        close: (function () {
                            setShowModal(function (param) {
                                  return false;
                                });
                          })
                      }) : null,
                JsxRuntime.jsxs("a", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h1", {
                                      children: name,
                                      className: "is-size-5 is-family-primary"
                                    }),
                                JsxRuntime.jsxs("p", {
                                      children: [
                                        LumiReact.renderOption(undefined, shortAddress, (function (address) {
                                                return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                            children: [
                                                              address,
                                                              JsxRuntime.jsx("br", {})
                                                            ]
                                                          });
                                              })),
                                        JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                              entry: {
                                                TAG: "Capacity",
                                                _0: info.totalPlaces
                                              }
                                            }),
                                        JsxRuntime.jsx("br", {}),
                                        JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                              entry: tmp
                                            })
                                      ],
                                      className: "is-size-6"
                                    })
                              ],
                              className: "facility-item-text"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp$1,
                              className: "facility-item-message-box"
                            })
                      ],
                      className: "facility-item bike-facility-item",
                      onClick: (function (param) {
                          setShowModal(function (param) {
                                return true;
                              });
                        })
                    })
              ]
            });
}

var Facility = {
  make: BikeFacilityList$Facility
};

function BikeFacilityList(props) {
  var imgBikeLower = props.imgBikeLower;
  var imgBikeUpper = props.imgBikeUpper;
  var displayAddress = props.displayAddress;
  var website = props.website;
  var fullThreshold = props.fullThreshold;
  return JsxRuntime.jsx("div", {
              children: props.bikeFacilityData.map(function (zippedParkingCounts) {
                    var fullThreshold$1 = fullThreshold(zippedParkingCounts);
                    var website$1 = website(zippedParkingCounts);
                    return JsxRuntime.jsx(BikeFacilityList$Facility, {
                                zippedParkingCounts: zippedParkingCounts,
                                fullThreshold: fullThreshold$1,
                                website: website$1,
                                displayAddress: displayAddress,
                                imgBikeUpper: imgBikeUpper,
                                imgBikeLower: imgBikeLower
                              }, zippedParkingCounts.info.id);
                  }),
              className: "facility-list-section"
            });
}

var T;

var make = BikeFacilityList;

export {
  T ,
  Facility ,
  make ,
}
/* react Not a pure module */
